
import { defineComponent, onMounted } from 'vue';
import { AppDateTimePicker, AppFileUpload, AppImageHolder } from '@/components';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { usePiggybankBoost } from '@/modules/piggybank/model/boost';
import { renderOption } from '@/common/utils/helpers';
import { PiggyBankBoostStatus } from '@/modules/piggybank/model/mixins';
import { ROUTE_NAME_PIGGYBANK } from '@/modules/piggybank/router';

export default defineComponent({
    name: ROUTE_NAME_PIGGYBANK.BOOST,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppDateTimePicker, AppFileUpload, AppImageHolder },
    setup() {
        const { model, v$, fetch, actions } = usePiggybankBoost();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions, renderOption, PiggyBankBoostStatus };
    }
});
